module.exports = __webpack_public_path__ + "frontend/images/logos/small/small-gold@2.png?7a740fcc83fee95dc134415c42596841";